import React from "react";

import {templates} from "@reactivated";

import {Layout} from "@client/components/Layout";
import { ErrorPage } from "@client/components/ErrorPage";


export const Template = (props: templates.InternalServerError500) => (
    <Layout title="Server Error">
        <ErrorPage
            title="500 Internal Server Error"
            description="An internal error has occurred, please try again later. If the problem persists, contact the system administrator."
        ></ErrorPage>
    </Layout>
);
